import { render, staticRenderFns } from "./gaia-footer.vue?vue&type=template&id=ad763b18&scoped=true&"
import script from "./gaia-footer.vue?vue&type=script&lang=js&"
export * from "./gaia-footer.vue?vue&type=script&lang=js&"
import style0 from "./gaia-footer.vue?vue&type=style&index=0&id=ad763b18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad763b18",
  null
  
)

export default component.exports